import { render, staticRenderFns } from "./VentanaOperacionesDespacho.vue?vue&type=template&id=0d783865"
import script from "./VentanaOperacionesDespacho.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesDespacho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports